var console;
if (typeof global !== 'undefined' && global.console) {
    console = global.console
} else if (typeof window !== 'undefined' && window.console) {
    console = window.console
} else {
    console = window.console = {}
}
module.exports = console;
for(var name in {log:1, info:1, error:1, warn:1, dir:1, trace:1, assert:1, time:1, timeEnd: 1})
	if(!console[name])
		console[name] = function() {};
